function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import * as ReactDom from 'react-dom';
export var createPortalInstance = function createPortalInstance() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    getContainer: function getContainer() {
      return document.body;
    }
  },
      getContainer = _ref.getContainer;

  var wrapper = document.createElement('div');

  var ref = function ref(element) {
    instance.component = element;
  };

  var instance = createComponentInstance({
    container: wrapper,
    mount: function mount(comp, key, props) {
      var root = getContainer();

      if (instance.container instanceof HTMLElement) {
        root.appendChild(instance.container);
        ReactDom.render( /*#__PURE__*/ReactDom.createPortal( /*#__PURE__*/React.createElement(comp, _objectSpread({
          ref: ref,
          key: key
        }, props)), instance.container), instance.container);
      }
    },
    unMount: function unMount() {
      if (instance.container instanceof HTMLElement) {
        var flag = ReactDom.unmountComponentAtNode(instance.container);
        if (!flag) return;
        instance.container.remove();
      }
    }
  });
  return instance;
};
export var createComponentInstance = function createComponentInstance(_ref2) {
  var _ref2$container = _ref2.container,
      container = _ref2$container === void 0 ? null : _ref2$container,
      _mount = _ref2.mount,
      _unMount = _ref2.unMount;
  var instance = {
    isMounted: false,
    container: container,
    component: null,
    children: createChildren(),
    mount: function mount(comp, key) {
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (instance.isMounted) {
        return;
      }

      try {
        _mount(comp, key, props);

        instance.isMounted = true;
      } catch (e) {}
    },
    unMount: function unMount() {
      if (!instance.isMounted) return;
      instance.clear();

      _unMount();

      instance.isMounted = false;
      instance.component = null;
    },
    clear: function clear() {
      instance.children.forEach(function (child) {
        child.unMount();
      });
      instance.children.clear();
    }
  };
  return instance;
};
export var createChildren = function createChildren() {
  var c = new Set();
  var list = {
    get __fake_set() {
      return true;
    },

    get size() {
      return c.size;
    },

    clear: function clear() {
      return c.clear();
    },
    push: function push(instance, args) {
      instance.mount.apply(instance, _toConsumableArray(args));
      c.add(instance);
    },
    delete: function _delete(instance) {
      c.delete(instance);
    },
    forEach: function forEach(callback) {
      c.forEach(callback);
    }
  };
  return list;
};